export default "https://cdn-static.gokick.com/assets/f4ff00fe02dd4df624a9917ee1bd81ca642b4b73/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";